import { useState } from 'react';

export default function TestimonialSection() {
  const testimonials = [
    {
      quote: "Robin and her team fought tirelessly for my workers' compensation claim. After my employer denied my injury, I didn't know where to turn. They took my case, handled everything professionally, and secured the benefits I needed to support my family during recovery.",
      author: 'Michael R.',
      case: 'Industrial Accident',
      location: 'Cuyahoga County',
    },
    {
      quote: "I was overwhelmed by the workers' compensation process after my workplace injury. Robin explained everything clearly, answered all my questions, and made sure I received every benefit I was entitled to. Her expertise and compassion made all the difference.",
      author: 'Sarah T.',
      case: 'Repetitive Strain Injury',
      location: 'Summit County',
    },
    {
      quote: "After years of back pain from my job, I finally sought legal help. Robin's knowledge of Ohio workers' compensation law is exceptional. She secured a settlement that exceeded my expectations and helped me get the medical treatment I desperately needed.",
      author: 'James K.',
      case: 'Occupational Injury',
      location: 'Portage County',
    },
  ];

  const [currentIndex, setCurrentIndex] = useState(0);

  const handlePrevious = () => {
    setCurrentIndex((prev) => (prev === 0 ? testimonials.length - 1 : prev - 1));
  };

  const handleNext = () => {
    setCurrentIndex((prev) => (prev === testimonials.length - 1 ? 0 : prev + 1));
  };

  return (
    <section className="py-32 bg-gradient-to-br from-gray-100 to-gray-50">
      <div className="max-w-6xl mx-auto px-6 lg:px-8">
        <div className="relative">
          <button
            onClick={handlePrevious}
            className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-16 w-12 h-12 flex items-center justify-center bg-white rounded-full shadow-lg hover:bg-gray-50 transition-colors z-10"
            aria-label="Previous testimonial"
          >
            <i className="ri-arrow-left-s-line text-2xl text-gray-900"></i>
          </button>

          <div className="text-center">
            <i className="ri-double-quotes-l text-6xl text-teal-600 mb-8 inline-block"></i>
            <blockquote className="font-serif text-3xl lg:text-4xl font-medium text-gray-900 leading-relaxed mb-12">
              {testimonials[currentIndex].quote}
            </blockquote>
            <div className="flex items-center justify-center space-x-3 text-gray-600">
              <span className="text-base font-semibold text-gray-900">
                {testimonials[currentIndex].author}
              </span>
              <span className="text-gray-400">—</span>
              <span className="text-sm">{testimonials[currentIndex].case}</span>
              <span className="text-gray-400">•</span>
              <span className="text-sm">{testimonials[currentIndex].location}</span>
            </div>
          </div>

          <button
            onClick={handleNext}
            className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-16 w-12 h-12 flex items-center justify-center bg-white rounded-full shadow-lg hover:bg-gray-50 transition-colors z-10"
            aria-label="Next testimonial"
          >
            <i className="ri-arrow-right-s-line text-2xl text-gray-900"></i>
          </button>
        </div>

        <div className="flex justify-center space-x-2 mt-12">
          {testimonials.map((_, index) => (
            <button
              key={index}
              onClick={() => setCurrentIndex(index)}
              className={`w-3 h-3 rounded-full transition-all ${
                index === currentIndex ? 'bg-teal-600 w-8' : 'bg-gray-300'
              }`}
              aria-label={`Go to testimonial ${index + 1}`}
            />
          ))}
        </div>
      </div>
    </section>
  );
}